<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_229_144)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.12658 12C2.12658 6.54706 6.54706 2.12658 12 2.12658C17.4529 2.12658 21.8734 6.54706 21.8734 12C21.8734 17.4529 17.4529 21.8734 12 21.8734C6.54706 21.8734 2.12658 17.4529 2.12658 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM16.3974 10.3215C16.8127 9.90624 16.8127 9.233 16.3974 8.81776C15.9822 8.40252 15.3089 8.40252 14.8937 8.81776L10.7848 12.9267L9.10629 11.2481C8.69105 10.8329 8.01781 10.8329 7.60257 11.2481C7.18733 11.6634 7.18733 12.3366 7.60257 12.7519L10.0329 15.1822C10.4482 15.5975 11.1214 15.5975 11.5367 15.1822L16.3974 10.3215Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_229_144">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
